export const startAudioRecordingController = async () => {
  const startAudioReco = document.getElementById("startAudioRecording");

  if (startAudioReco === null) {
  } else {
    startAudioReco.click();
  }
};
